import React from "react";
import { Form } from "semantic-ui-react";
import Only from "react-only-when";
import PropTypes from "prop-types";
import styles from "./styles.less";
import cx from "classnames";

class FormInput extends React.Component {
  state = {
    value: "",
    open: false,
    isInvalid: false,
    onTimeValid: false
  };

  componentDidMount() {
    const { value } = this.props;
    if (value && value.toString().length > 0) {
      this.setState({
        value: value,
        open: true
      });
    }
  }

  componentDidUpdate() {
    const { value: mabyeNewValue } = this.props;
    const { value: mabyeOldValud } = this.state;
    if (mabyeNewValue !== mabyeOldValud) {
      let nextState = {
        value: mabyeNewValue
      };
      if (mabyeNewValue && mabyeNewValue.toString().length > 0) {
        nextState.open = true;
      }
      this.setState(nextState);
    }
  }

  /**
   * get called only after valid input has entered AND only if any validation is exist.
   */
  onInput = e => {
    const validityState = e.target.validity;
    if (
      // all exclude custom error that should be true and ignored
      !(
        validityState.badInput ||
        validityState.patternMismatch ||
        validityState.rangeOverflow ||
        validityState.rangeUnderflow ||
        validityState.stepMismatch ||
        validityState.tooLong ||
        validityState.tooShort ||
        validityState.typeMismatch ||
        validityState.valueMissing
      )
    ) {
      e.target.setCustomValidity("");
      this.setState({
        isInvalid: false,
        onTimeValid: true
      });
    } else {
      this.setState({
        onTimeValid: false
      });
    }
  };

  /**
   * get called only after form submitted and input is not valid.
   */
  onInvalid = e => {
    let { customValidation, titles } = this.props;

    const validityState = e.target.validity;
    if (validityState.tooLong) {
      customValidation = titles.ValidationTooLong;
    } else if (validityState.tooShort) {
      customValidation = titles.ValidationTooShort;
    } else if (validityState.patternMismatch) {
      customValidation = titles.ValidationPatternMismatch;
    } else if (validityState.typeMismatch) {
      customValidation = titles.ValidationTypeMismatch;
    } else if (
      e.target.required &&
      e.target.value == null &&
      customValidation == null
    ) {
      customValidation = titles.ThisFieldIsMust;
    }

    if (customValidation != undefined) {
      e.target.setCustomValidity(customValidation);
    }

    this.setState({
      isInvalid: true
    });
  };

  /**
   * get called on every input change
   */
  onInputChange = e => {
    const { onChange, name } = this.props;
    this.setState({ value: e.target.value });
    this.onInput(e);
    onChange && onChange(e.target.value, name);
  };

  onInputFocus = () => {
    this.setState({
      open: true
    });
  };

  onInputBlur = e => {
    const { onInputBlur, name } = this.props;
    if (e.target.value.trim() === "") {
      this.setState({
        open: false
      });
    }
    onInputBlur && onInputBlur(e.target.value, name);
  };

  render() {
    const {
      name,
      value,
      label,
      textarea,
      type,
      required,
      minLength,
      maxLength,
      pattern,
      disabled,
      error,
      errorMessage,
      className
    } = this.props;
    const { open, isInvalid, onTimeValid } = this.state;

    const isTextArea = textarea ? true : false;
    const isRequired = required ? true : false;

    const toRender = (
      <Form.Field
        className={cx(styles.formInput, className, {
          [styles.disabled]: disabled
        })}
      >
        <Only when={!isTextArea}>
          <input
            className={cx(styles.inputElement, {
              [styles.invalid]: isInvalid || error || errorMessage != null
            })}
            name={name}
            value={value}
            type={type}
            onChange={this.onInputChange}
            required={isRequired}
            minLength={minLength}
            maxLength={maxLength}
            pattern={pattern}
            onInvalid={this.onInvalid}
            onInput={this.onInput}
            disabled={disabled}
            onFocus={this.onInputFocus}
            onBlur={this.onInputBlur}
          />
        </Only>
        <Only when={isTextArea}>
          <textarea
            className={cx(styles.inputElement, styles.inputElementText)}
            name={name}
            value={value}
            onChange={this.onInputChange}
            required={isRequired}
            onInvalid={this.onInvalid}
            onInput={this.onInput}
            onFocus={this.onInputFocus}
            onBlur={this.onInputBlur}
            disabled={disabled}
          />
        </Only>
        <label
          className={cx(styles.inputLabel, {
            [styles.open]: open,
            [styles.textarea]: isTextArea
          })}
        >
          {isRequired &&
            !onTimeValid && <span className={styles.required}>*</span>}
          {label}
        </label>
        <Only when={errorMessage != null}>
          <div className={styles.errorMessage}>{errorMessage}</div>
        </Only>
        {/* <span className="anim-input-enter" /> */}
      </Form.Field>
    );

    return toRender;
  }
}

FormInput.propTypes = {
  titles: PropTypes.object,
  customValidation: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  minLength: PropTypes.string,
  maxLength: PropTypes.string,
  pattern: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  textarea: PropTypes.bool,
  type: PropTypes.string,
  onInputBlur: PropTypes.func,
  error: PropTypes.bool,
  errorMessage: PropTypes.string
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/common/Form/FormInput/FormInput.js